import React from "react";

/**
 * @component MoonIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <MoonIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const MoonIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="MoonIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.06.509a1 1 0 01-.067 1.085 6.015 6.015 0 008.413 8.413 1 1 0 011.59.896A10.02 10.02 0 119.097.004a1 1 0 01.963.505zm-2.765 1.93a8.019 8.019 0 1010.266 10.266A8.014 8.014 0 017.295 2.439z"
      />
    </svg>
  )
);
MoonIcon.displayName = "MoonIcon";
export default MoonIcon;
